import { render, staticRenderFns } from "./AppSumoPlans.vue?vue&type=template&id=6435b811"
import script from "./AppSumoPlans.vue?vue&type=script&lang=js"
export * from "./AppSumoPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports